import { h, render, Component } from 'preact';
import TxrNavbar from './txr-navbar';
import { classNames } from '../utils/utils';

class TxrBottomGetStarted extends Component {

    render() {
        return (
            <div class="txr-bottom-get-started">
                <div class="txr-bottom-get-started__top-image txr-art-dot__image"></div>
                <div class="txr-bottom-get-started__content">
                    <h3 class="txr-bottom-get-started__header txr-h">LET’S GO</h3>
                    <h2 class="txr-bottom-get-started__title txr-h">Ready to start using Text Request for your business?</h2>
                    <div class="txr-bottom-get-started__button">
                        <button class="txr-button txr-primary-button txr-width200" type="button">
                                <span class="txr-button__content">
                                GET STARTED
                                    <i class="txr-button__angle-icon fal fa-angle-right"></i>
                                </span>
                            </button>
                        </div>
                </div>
            </div>
        )
    }
}

export default TxrBottomGetStarted;